module.exports = __webpack_public_path__ + "static/media/SerenaLertkantitham.0418cedf.jpg";